import React, { useState, FC } from 'react';

export enum TutorialEnum {
  one,
  two,
  three
}

interface ITutorialContext {
  tutorialType: TutorialEnum;
  setTutorialType: React.Dispatch<React.SetStateAction<TutorialEnum>>;
  isModalClosed: boolean;
  setCloseModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const TutorialContext = React.createContext<ITutorialContext>({
  tutorialType: TutorialEnum.one,
  setTutorialType: {} as React.Dispatch<React.SetStateAction<TutorialEnum>>,
  isModalClosed: false,
  setCloseModal: {} as React.Dispatch<React.SetStateAction<boolean>>
});

interface ITutorialState {
  children: any;
}

export const TutorialState: FC<ITutorialState> = ({ children }) => {
  const [tutorial, setTutorial] = useState(TutorialEnum.one);
  const [isModalClosed, setIsModalClosed] = useState(true);

  return (
    <TutorialContext.Provider
      value={{
        tutorialType: tutorial,
        setTutorialType: setTutorial,
        isModalClosed,
        setCloseModal: setIsModalClosed
      }}
    >
      {children}
    </TutorialContext.Provider>
  );
};
